<template>
  <!-- 组管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-title-hang class="config_hight_change_scene_manage">
        <span slot="config_title_hang_ele4">右击可删除一个组</span>
        <img slot="config_title_hang_ele3"
             src="~assets/img/config/tishilaba.png"
             alt />
      </config-title-hang>

      <config-hang @click.native="configAddGroupBtnHandle">
        <span slot="config_hang_ele2">添加一个组</span>
        <img slot="config_hang_ele4"
             src="~assets/img/config/youjiantou.png"
             alt />
      </config-hang>
      <config-title-hang>
        <span slot="config_title_hang_ele2">已有组列表</span>
      </config-title-hang>

      <config-hang v-for="(value , index) in ServeGroupData"
                   :key="index"
                   @click.native="xiuGaiGroupBtnHandle(value)"
                   @contextmenu.prevent.native="oneGroupRightClickBtnHandle(value ,index )">
        <span slot="config_hang_ele2">{{value.deviceName}}</span>
        <span slot="config_hang_ele3">({{value.regionName}})</span>
        <img slot="config_hang_ele4"
             src="~assets/img/config/youjiantou.png"
             alt />
      </config-hang>
      <div class="xiaotishi_style">小提示：删除组操作时，子账号尽量不要控制设备，否则可能出现删除组失败的情况~。</div>

    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
export default {
  data () {
    return {
      ServeGroupData: [],
      OneGroupinfo: {
        deleteState: 1,
        iconId: '',
        iconUrl: '',
        deviceId: '',
        deviceName: '',
        productCode: '',
        productName: '',
        regionId: '',
        regionName: '请选择一个区域',

        followState: null,
        groupNo: null
      }
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    configAddGroupBtnHandle () {
      ///添加一个组按钮
      ///需要先把仓库的一个组的数据都给清空复原
      ////提交一个要修改的组信息的地址到仓库（注意看上去是提交了一个地址，但其实是在提交过程中做了一个深度克隆，并不是提交地址）
      this.$store.dispatch('asyUpdataOneGroupinfo', this.OneGroupinfo)
      this.$router.push('/ConfigGroupMain/ConfigAddGroup')
    },
    xiuGaiGroupBtnHandle (value) {
      this.$store.dispatch('asyUpdataOneGroupinfo', value)
      this.$router.push({ path: '/ConfigGroupMain/ConfigAddGroup', query: { title: '修改一个组' } })
    },
    oneGroupRightClickBtnHandle (value, index) {
      ////一个组管理的右击事件
      console.log('组的右击事件')
      this.$showTipsToast(23, value, false, 1000, index)
    }
  },

  mounted () {
    console.log('mounted阶段')
  },
  created () {
    console.log('created阶段')
    /// 请求组信息接口，获取数据
    this.$request({
      method: 'post',
      url: '/userGroup/findUserGroupList',
      data: {
        token: this.$store.state.token
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.ServeGroupData = res.data.data ////拿到服务器返回的数据结果
          this.$store.dispatch('asyUpdataServeGroupData', this.ServeGroupData) ///异步提交信息到仓库
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
.config_hight_change_scene_manage {
  height: 40px;
  line-height: 40px;
}
.config_hight_change_scene_manage img {
  right: 165px;
}
</style>